import React from 'react';
import { Link } from 'react-router-dom';
import './../styles/Button.css';

// Navigates to login page on click
const LoginButton = () => {
    return (
        <Link to="/login" className="login-button">
            Login
        </Link>
    );
};

export default LoginButton;
